<template>
    <div ref="videoPlayer" class="video-js" id="id_aliplayer"></div>
</template>

<script>

export default {
  name: "video-player",
  props: {
    options: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      player: null
    };
  },
  mounted() {
    // this.player = videojs(this.$refs.videoPlayer, this.options, function onPlayerReady() {
    //     console.log('onPlayerReady', this);
    // })
    //  https://help.aliyun.com/document_detail/125572.html?spm=a2c4g.11186623.2.24.65f41c4cH9CV8M
    // https://dev.pydp888.com/poster/v/?src=https%3A%2F%2Fimgcdn-dev.pydp888.com%2Fmts%2Foutput%2F20200521%2F3%2F1590057212%2Foutput.m3u8
    // https://dev.pydp888.com/poster/v/?src=https%3A%2F%2Fimgcdn-dev.pydp888.com%2Fmts%2Foutput%2F20200521%2F1%2F1590044707%2Foutput.m3u8
    var player = new Aliplayer(
      {
        id: "id_aliplayer",
        width: "100%",
        height: "100%",
        videoWidth: "100%",
        autoplay: false,
        //支持播放地址播放,此播放优先级最高
        source: this.options.src,
        // //播放方式二：点播用户推荐
        // vid: "1e067a2831b641db90d570b6480fbc40",
        // playauth: "ddd",
        cover: this.options.poster || null,
        // encryptType: 1, //当播放私有加密流时需要设置。
        // //播放方式三：仅MPS用户使用
        // vid: "1e067a2831b641db90d570b6480fbc40",
        // accId: "dd",
        // accSecret: "dd",
        // stsToken: "dd",
        // domainRegion: "dd",
        // authInfo: "dd",
        // //播放方式四：使用STS方式播放
        // vid: "1e067a2831b641db90d570b6480fbc40",
        // accessKeyId: "dd",
        // securityToken: "dd",
        // accessKeySecret: "dd",
        // region: "cn-shanghai" //eu-central-1,ap-southeast-1
      },
      function(player) {
        console.log("播放器创建好了。");
      }
    );
  },
  beforeDestroy() {
    // if (this.player) {
    //     this.player.dispose()
    // }
  }
};
</script>
